import { CircularProgress, Box } from '@mui/material';
import type { UserRole } from '@pe/shared';
import { Navigate, Outlet, useLocation } from 'react-router-dom';

import { useAuthStore } from '../../stores/auth-store';

interface Props {
  allowedRoles?: UserRole[];
}

export function ProtectedRoute({ allowedRoles }: Props) {
  const { status, user } = useAuthStore();
  const location = useLocation();

  if (status === 'unknown') {
    return (
      <Box
        sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '60vh' }}
      >
        <CircularProgress aria-label="Chargement" />
      </Box>
    );
  }

  if (status !== 'authenticated' || !user) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  if (allowedRoles && !allowedRoles.includes(user.role)) {
    return <Navigate to="/app" replace />;
  }

  return <Outlet />;
}
